<template>
    <div class="invoiceViewer" v-if="invoice">
        <div class="watermark" v-if="invoice.state == 'draft'"> Borrador </div>
        <div id="Invoice_1">
            <div class="pl-12 pr-4">
                <div v-if="configuration && configuration.path_url" class="d-flex pt-12">
                    <v-col cols="9" class="pa-0 ma-0">
                        <v-container class="pa-0 ">
                            <v-row v-if="invoice.rectificative">
                                <v-col cols="12" class="py-0">
                                    <div class="font-weight-bold">
                                        <p class="ma-0 text-h3">FACTURA RECTIFICATIVA</p>
                                        <p v-if="rectified_inv"> Rectifica la factura {{ rectified_inv.invoice_number }} del {{formatInvoiceDate(rectified_inv.invoice_date)}}</p>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col sm="6" md="5" lg="6">
                                    <div class="subtitle-1 font-weight-bold">
                                        <p class="ma-0"><b>Número {{invoice.name}}: </b> {{invoice.invoice_number}}</p>
                                    </div>
                                </v-col>
                                <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0" class="d-flex align-end" v-if="invoice.type == 'invoice'">
                                    <div class="caption">
                                        <p class="ma-0"><b>Número factura externo: </b> {{invoice.external_invoice_number}}</p>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col sm="6" md="5" lg="6">
                                    <div class="caption">
                                        <p class="ma-0"><b>Fecha {{invoice.name}}: </b> {{ formatInvoiceDate(invoice.invoice_date) }}</p>
                                    </div>
                                </v-col>
                                <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
                                    <div class="caption">
                                        <p class="ma-0"><b>Fecha vencimiento: </b> {{ formatInvoiceDate(invoice.invoice_due_date) }}</p>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col sm="6" md="5" lg="6">
                                    <div class="caption">
                                        <p class="ma-0"><b>Fecha inicio: </b> {{ formatInvoiceDate(invoice.start_date) }}</p>
                                    </div>
                                </v-col>
                                <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
                                    <div class="caption">
                                        <p class="ma-0"><b>Fecha final: </b> {{ formatInvoiceDate(invoice.end_date) }}</p>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters v-if="invoice.signing_time">
                                <v-col sm="6" md="5" lg="6">
                                    <div class="caption">
                                        <p class="ma-0"><b>Fecha firma: </b> {{ invoice.signing_time }}</p>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
        
                        <v-divider class="divider my-2"></v-divider>
        
                        <p class="subtitle-1 font-weight-bold ma-0">Emisor</p>
        
                        <v-container class="pa-0">
                            <v-row no-gutters>
                                <v-col  class="caption">
                                    <div v-if="invoice.supplier.type == 'juridica'">
                                        <p class="ma-0 "><b>Razón social: </b> {{invoice.supplier.business_name}}</p>
                                    </div>
                                    <div v-else>
                                        <p class="ma-0 "><b>Nombre fiscal: </b> {{ invoice.supplier.name }} {{ invoice.supplier.first_surname }} {{ invoice.supplier.second_surname }}</p>
                                    </div>
                                    <div v-if="invoice.supplier.email">
                                        <p class="ma-0"><b>Email: </b> {{invoice.supplier.email}}</p>
                                    </div>
                                    <div>
                                        <div class="d-flex align-start"> 
                                            <b class="mr-1">Domicilio fiscal: </b>
                                            <span class="d-flex flex-column align-start">
                                                <span> {{ invoice.supplier.address }}</span>
                                                <span> {{ invoice.supplier.post_code }} {{invoice.supplier.city}}</span>
                                                <span> {{ invoice.supplier.province }} ESP</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="invoice.supplier.phone">
                                        <p class="ma-0"><b>Teléfono:</b>{{invoice.supplier.phone}}</p>
                                    </div>
                                    <div v-if="invoice.supplier.website">
                                        <p class="ma-0"><b>Web: </b> {{invoice.supplier.website}}</p>
                                    </div>
                                </v-col>
        
                                <v-col class="caption">
                                    <div>
                                        <p class="ma-0"><b>NIF/CIF: </b> {{invoice.supplier.cif}}</p>
                                    </div>
                                    <div v-if="invoice.supplier.bank_account_number">
                                        <p class="ma-0"><b>Número de cuenta: </b> {{invoice.supplier.bank_account_number}}</p>
                                    </div>
                                    <div v-if="invoice.supplier.type == 'juridica'">
                                        <p class="ma-0"><b>Nombre Comercial: </b> {{invoice.supplier.trade_name}}</p>
                                    </div>
                                </v-col>
        
                            </v-row>
                        </v-container>

                        <v-divider class="divider my-2"></v-divider>
                
                        <p class="subtitle-1 font-weight-bold ma-0">Receptor</p>

                        <v-container class="pa-0">
                            <v-row no-gutters>
                                <v-col  class="caption">
                                    <div v-if="invoice.customer.type == 'juridica'">
                                        <p class="ma-0 "><b>Razón social: </b> {{invoice.customer.business_name}}</p>
                                    </div>
                                    <div v-else>
                                        <p class="ma-0 "><b>Nombre fiscal: </b> {{ invoice.customer.name }} {{ invoice.customer.first_surname }} {{ invoice.customer.second_surname }}</p>
                                    </div>
                                    <div>
                                        <div class="d-flex align-start"> 
                                            <b class="mr-1">Domicilio fiscal: </b>
                                            <span class="d-flex flex-column align-start">
                                                <span> {{ invoice.customer.address }}</span>
                                                <span> {{ invoice.customer.post_code }} {{invoice.customer.city}}</span>
                                                <span> {{ invoice.customer.province }} ESP</span>
                                            </span>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col class="caption">
                                    <div>
                                        <p class="ma-0"><b>NIF/CIF: </b> {{invoice.customer.cif}}</p>
                                    </div>
                                    <div v-if="invoice.customer.type == 'juridica'">
                                        <p class="ma-0"><b>Nombre Comercial: </b> {{invoice.customer.trade_name}}</p>
                                    </div>
                                    <div v-if="invoice.customer.DIRe">
                                        <p class="ma-0"> <b>DIRe:</b> {{ invoice.customer.DIRe }} </p>
                                    </div>
                                    <div v-if="invoice.customer.accounting_office">
                                        <p class="ma-0"> <b>Despacho contable:</b> {{ invoice.customer.accounting_office }} </p>
                                    </div>
                                    <div v-if="invoice.customer.management_body">
                                        <p class="ma-0"> <b>Órgano de gestión:</b> {{ invoice.customer.management_body }} </p>
                                    </div>
                                    <div v-if="invoice.customer.processing_unit">
                                        <p class="ma-0"> <b>Unidad tramitadora:</b> {{ invoice.customer.processing_unit }} </p>
                                    </div>
                                    <div v-if="invoice.customer.proposing_body">
                                        <p class="ma-0"> <b>Órgano proponente:</b> {{ invoice.customer.proposing_body }} </p>
                                    </div>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="3" class="pa-0 ma-0 first__row">
                        <img 
                            class="ml-6 logo"
                            :src="configuration.path_url">
                        </img>
                    </v-col>
                </div>

                <div v-else>
                    <v-container class="pa-0 pt-12">
                        <v-row v-if="invoice.rectificative">
                            <v-col cols="12" class="py-0">
                                <div class="font-weight-bold">
                                    <p class="ma-0 text-h3">FACTURA RECTIFICATIVA</p>
                                    <p v-if="rectified_inv"> Rectifica la factura {{ rectified_inv.invoice_number }} del {{formatInvoiceDate(rectified_inv.invoice_date)}}</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col sm="6" md="5" lg="6">
                                <div class="subtitle-1 font-weight-bold">
                                    <p class="ma-0"><b>Número {{invoice.name}}: </b> {{invoice.invoice_number}}</p>
                                </div>
                            </v-col>
                            <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0" class="d-flex align-end" v-if="invoice.type == 'invoice'">
                                <div class="caption">
                                    <p class="ma-0"><b>Número factura externo: </b> {{invoice.external_invoice_number}}</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col sm="6" md="5" lg="6">
                                <div class="caption">
                                    <p class="ma-0"><b>Fecha {{invoice.name}}: </b> {{ formatInvoiceDate(invoice.invoice_date) }}</p>
                                </div>
                            </v-col>
                            <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
                                <div class="caption">
                                    <p class="ma-0"><b>Fecha vencimiento: </b> {{ formatInvoiceDate(invoice.invoice_due_date) }}</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col sm="6" md="5" lg="6">
                                <div class="caption">
                                    <p class="ma-0"><b>Fecha inicio: </b> {{ formatInvoiceDate(invoice.start_date) }}</p>
                                </div>
                            </v-col>
                            <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
                                <div class="caption">
                                    <p class="ma-0"><b>Fecha final: </b> {{ formatInvoiceDate(invoice.end_date) }}</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="invoice.signing_time">
                            <v-col sm="6" md="5" lg="6">
                                <div class="caption">
                                    <p class="ma-0"><b>Fecha firma: </b> {{ invoice.signing_time }}</p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
    
                    <v-divider class="divider my-2"></v-divider>
    
                    <p class="subtitle-1 font-weight-bold ma-0">Emisor</p>
    
                    <v-container class="pa-0">
                        <v-row no-gutters>
                            <v-col  class="caption">
                                <div v-if="invoice.supplier.type == 'juridica'">
                                    <p class="ma-0 "><b>Razón social: </b> {{invoice.supplier.business_name}}</p>
                                </div>
                                <div v-else>
                                    <p class="ma-0 "><b>Nombre fiscal: </b> {{ invoice.supplier.name }} {{ invoice.supplier.first_surname }} {{ invoice.supplier.second_surname }}</p>
                                </div>
                                <div>
                                    <div class="d-flex align-start"> 
                                        <b class="mr-1">Domicilio fiscal: </b>
                                        <span class="d-flex flex-column align-start">
                                            <span> {{ invoice.supplier.address }}</span>
                                            <span> {{ invoice.supplier.post_code }} {{invoice.supplier.city}}</span>
                                            <span> {{ invoice.supplier.province }} ESP</span>
                                        </span>
                                    </div>
                                </div>
                            </v-col>
    
                            <v-col class="caption">
                                <div>
                                    <p class="ma-0"><b>NIF/CIF: </b> {{invoice.supplier.cif}}</p>
                                </div>
                                <div v-if="invoice.supplier.bank_account_number">
                                    <p class="ma-0"><b>Número de cuenta: </b> {{invoice.supplier.bank_account_number}}</p>
                                </div>
                                <div v-if="invoice.supplier.type == 'juridica'">
                                    <p class="ma-0"><b>Nombre Comercial: </b> {{invoice.supplier.trade_name}}</p>
                                </div>
                            </v-col>
    
                        </v-row>
                    </v-container>

                    <v-divider class="divider my-2"></v-divider>
                
                    <p class="subtitle-1 font-weight-bold ma-0">Receptor</p>

                    <v-container class="pa-0">
                        <v-row no-gutters>
                            <v-col  class="caption">
                                <div v-if="invoice.customer.type == 'juridica'">
                                    <p class="ma-0 "><b>Razón social: </b> {{invoice.customer.business_name}}</p>
                                </div>
                                <div v-else>
                                    <p class="ma-0 "><b>Nombre fiscal: </b> {{ invoice.customer.name }} {{ invoice.customer.first_surname }} {{ invoice.customer.second_surname }}</p>
                                </div>
                                <div>
                                    <div class="d-flex align-start"> 
                                        <b class="mr-1">Domicilio fiscal: </b>
                                        <span class="d-flex flex-column align-start">
                                            <span> {{ invoice.customer.address }}</span>
                                            <span> {{ invoice.customer.post_code }} {{invoice.customer.city}}</span>
                                            <span> {{ invoice.customer.province }} ESP</span>
                                        </span>
                                    </div>
                                </div>
                            </v-col>

                            <v-col class="caption">
                                <div>
                                    <p class="ma-0"><b>NIF/CIF: </b> {{invoice.customer.cif}}</p>
                                </div>
                                <div v-if="invoice.customer.type == 'juridica'">
                                    <p class="ma-0"><b>Nombre Comercial: </b> {{invoice.customer.trade_name}}</p>
                                </div>
                                <div v-if="invoice.customer.DIRe">
                                    <p class="ma-0"> <b>DIRe:</b> {{ invoice.customer.DIRe }} </p>
                                </div>
                                <div v-if="invoice.customer.accounting_office">
                                    <p class="ma-0"> <b>Despacho contable:</b> {{ invoice.customer.accounting_office }} </p>
                                </div>
                                <div v-if="invoice.customer.management_body">
                                    <p class="ma-0"> <b>Órgano de gestión:</b> {{ invoice.customer.management_body }} </p>
                                </div>
                                <div v-if="invoice.customer.processing_unit">
                                    <p class="ma-0"> <b>Unidad tramitadora:</b> {{ invoice.customer.processing_unit }} </p>
                                </div>
                                <div v-if="invoice.customer.proposing_body">
                                    <p class="ma-0"> <b>Órgano proponente:</b> {{ invoice.customer.proposing_body }} </p>
                                </div>
                            </v-col>

                        </v-row>
                    </v-container>
                </div>


            </div>
            <div class="ml-12 mr-4 py-2 mt-4 primary_blue">
                <p class="my-0 mr-0 ml-2 subtitle-1 font-weight-bold white--text">
                    Detalles
                    <span  v-if="invoice.type == 'budget'">
                        del presupuesto
                    </span>
                    <span  v-if="invoice.type == 'delivery_note'">
                        del albarán 
                    </span>
                    <span  v-else>
                        de la factura
                    </span>
                </p>
            </div>
            <div class="pl-12 mr-4">
                <table cellspacing="0" cellpadding="0" class="table">
                    <thead class="table__header">
                        <tr>
                            <th class="text-left col-6">Descripción</th>
                            <th class="text-center col-1">Cantidad</th>
                            <th class="text-center col-1">Precio unitario</th>
                            <th class="text-center col-1">Descuento %</th>
                            <th class="text-center col-1">{{tax_type_to_show}}</th>
                            <th class="text-center col-1">Retención</th>
                            <th class="text-right table__total col-1">Total</th>
                        </tr>
                    </thead>
                    <tbody class=table__body>
                        <tr id="Invoice_1_1" v-for="item in computed_lines">
                            <template v-if="!item.is_additional_info">
                                <td> 
                                    <!-- si té informació adicional i té algun dels camps originals. -->
                                    <span v-if="item.additional_information && 
                                                (item.additional_information.delivery_note_number || 
                                                item.additional_information.delivery_note_date ||
                                                (item.additional_information.sender_info &&
                                                (item.additional_information.sender_info.budget_number || item.additional_information.sender_info.budget_date)) ||
                                                (item.additional_information.receiver_info &&
                                                (item.additional_information.receiver_info.budget_number || item.additional_information.receiver_info.budget_date)))">
                                        <span v-if="item.additional_information.delivery_note_number && item.additional_information.delivery_note_date">
                                            <b>Albarán {{ item.additional_information.delivery_note_number }} del {{ formatInvoiceDate(item.additional_information.delivery_note_date) }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.delivery_note_number">
                                            <b>Albarán {{ item.additional_information.delivery_note_number }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.delivery_note_date">
                                            <b>Fecha del albarán: {{ formatInvoiceDate(item.additional_information.delivery_note_date) }}</b>
                                        </span>
                                        <span v-if="item.additional_information.sender_info.budget_number && item.additional_information.sender_info.budget_date">
                                            - <b>Presupuesto emisor {{ item.additional_information.sender_info.budget_number }} del {{ formatInvoiceDate(item.additional_information.sender_info.budget_date) }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.sender_info.budget_number">
                                            - <b>Presupuesto emisor {{ item.additional_information.sender_info.budget_number }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.sender_info.budget_date">
                                            - <b>Fecha del presupuesto emisor: {{ formatInvoiceDate(item.additional_information.sender_info.budget_date) }}</b>
                                        </span>
                                        <span v-if="item.additional_information.receiver_info.budget_number && item.additional_information.receiver_info.budget_date">
                                            - <b>Presupuesto receptor {{ item.additional_information.receiver_info.budget_number }} del {{ formatInvoiceDate(item.additional_information.receiver_info.budget_date) }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.receiver_info.budget_number">
                                            - <b>Presupuesto receptor {{ item.additional_information.receiver_info.budget_number }}</b>
                                        </span>
                                        <span v-else-if="item.additional_information.receiver_info.budget_date">
                                            - <b>Fecha del presupuesto receptor: {{ formatInvoiceDate(item.additional_information.receiver_info.budget_date) }}</b>
                                        </span>
                                        <br>
                                    </span>
                                    <span> 
                                        {{ item.description }}
                                    </span>
                                    <!-- <span v-if="item.additional_information &&
                                                item.additional_information.additional_line_information && 
                                                item.additional_information.additional_line_information.trim()">
                                        <br>
                                        {{ item.additional_information.additional_line_information }}
                                    </span> -->
                                </td>
                                <td class="text-right">{{ item.quantity }}</td>
                                <td class="text-right">{{ item.unit_price_without_tax }} €</td> 

                                <td class="text-right">
                                    <span v-if="item.discounts && item.discounts.length > 0">
                                        {{ formatField(item.discounts[0].rate) }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </td>

                                <td class="text-right">
                                    <span v-if="item.taxes.length > 0">
                                        {{ formatField(item.selected_tax) }} {{ item.selected_tax_event != 'N/A'? ' '+item.selected_tax_event: '' }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </td> 
                                <td class="text-right">
                                    <span v-if="item.selected_retention">
                                        {{ formatField(item.selected_retention) }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </td> 
                                <td class="text-right">{{ item.gross_amount.toFixed(2) }} € </td>
                            </template>
                            <template v-if="item.is_additional_info">
                                <td colspan="7" style="width: 100%;" v-html="item.additional_information ? item.additional_information.additional_line_information.replace(/\n/g, '<br>') : ''">
                                    
                                </td>
                            </template>
                            
                        </tr>                       
                    </tbody>
                    <tfoot class="table__footer" v-if="invoice.additional_info">
                        <tr>
                            <td colspan="7" class="text-left">
                                <b v-html="invoice.additional_info.replace(/\n/g, '<br>')"></b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div class="totals mt-6 w-100">
                    <!-- Total sin impuestos ni descuentos (solo se muestra si hay descuento por línea, NO si hay descuento global) -->
                    <div class="custom-row" v-if="invoice.total_lines_discounts > 0">
                        <span>Total sin descuentos</span>
                        <span class="custom-total">
                            <span>{{ invoice.total_gross_amount.toFixed(2) + ' €' }}</span>
                        </span>
                    </div>

                    <!-- Descuento por linea -->
                    <div class="custom-row" v-if="invoice.total_lines_discounts > 0">
                        <span>Descuento por línea</span>
                        <span class="custom-total">
                            <span>{{ (-invoice.total_lines_discounts).toFixed(2) + ' €' }}</span>
                        </span>
                    </div>

                    <div class="custom-row">
                        <span>
                            Total sin impuestos
                        </span>
                        <span class="custom-total">
                            <span>{{invoice.total_gross_amount_before_tax.toFixed(2) + ' €'}}</span>
                        </span>
                    </div>

                    <div class="custom-row" v-for="item in invoice.total_taxes" :key="item.rate.toString() +'_t'">
                        <span>
                            Total {{tax_type_to_show}} {{ (item.rate * 100).toFixed(2) }}&nbsp;% {{ '(Base: '+ item.base.toFixed(2).toString()+ ' €)' }}
                        </span>
                        <span class="custom-total">
                            <span>{{item.amount.toFixed(2).toString() + ' €'}}</span>
                        </span>
                    </div>

                    <div class="custom-row" v-for="item in invoice.total_taxes_withheld">
                        <span>
                            Total Retención {{ (item.rate * 100).toFixed(0) }}&nbsp;% {{ '(Base: ' + item.base.toFixed(2) + ' €)' }}
                        </span>
                        <span class="custom-total">
                            <span>{{ (-item.amount).toFixed(2) + ' €' }}</span>
                        </span>
                    </div>
                    <div class="custom-row">
                        <span>
                            Total {{invoice.name}}
                        </span>
                        <span class="custom-total">
                            <span>{{invoice.total_amount.toFixed(2).toString() + ' €'}}</span>
                        </span>
                    </div>
                    <!-- Descuento global -->
                    <div class="custom-row" v-if="invoice.general_discounts && invoice.general_discounts.length > 0">
                        <span>Descuento global</span>
                        <small class="description" v-if="invoice.general_discounts.reason">
                            {{ '(' + invoice.general_discounts[0].reason + ')' }}
                        </small>
                        <span class="custom-total">
                            <span>{{ (-invoice.general_discounts[0].amount).toFixed(2) + ' €' }}</span>
                        </span>
                    </div>
                    <template v-if="invoice.retention_amount">
                        <div class="custom-row">
                            <span>
                                Retención: &nbsp <b>{{ invoice.retention_concept }}</b>
                            </span>
                            <span class="custom-total">
                                <span>{{-invoice.retention_amount.toString() + ' €'}}</span>
                            </span>
                        </div>
                    </template>
                    <template v-if="invoice.reimbursable_amounts && invoice.reimbursable_amounts.length > 0">
                        <div class="custom-row">
                            <span>
                                Suplido: &nbsp
                            </span>
                            <span class="custom-total">
                                <span>{{invoice.reimbursable_amounts[0].toString() + ' €'}}</span>
                            </span>
                        </div>
                    </template>
                    <div class="custom-row">
                        <div class="custom-message-left">
                            {{ payment_message(invoice.payment_means) }}
                        </div>
                        <span class="primary_blue--text font-weight-bold">
                            Total a pagar
                        </span>
                        <span class="custom-total-last">
                            <span>{{invoice.total_to_pay.toFixed(2).toString() + ' €'}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="configuration && configuration.footer" class="pl-12 pt-6">
            <small><b>{{configuration.footer}}</b></small>
        </div>
        <div v-if="configuration && configuration.footer_small" class="pl-12 pt-1">
            <p style="font-size: 10px; line-height: 18px;">
                {{configuration.footer_small}}
            </p>
        </div>
    </div>
</template>


<script>

import {Invoiceable} from '../modules/facturae/domain/Invoiceable'
import { Configuration } from '@/modules/facturae/domain/Configuration';
import { getPaymentMeansMessage } from '../modules/facturae/domain/Invoiceable';
export default {

    props: {
        invoice: {
            type: Invoiceable,
        },
        configuration:{
            type: Configuration
        },
        rectified_inv:{
            type: Invoiceable,
            default: null
        }
    },
    data() {
        return {
        }
    },	

    watch: {
        invoice_lines: {
        handler(nuevoValor, antiguoValor) {
            console.log('La lista ha cambiado:', nuevoValor);
            // Realizar acciones adicionales en respuesta al cambio
        },
        deep: true, // Necesario para detectar cambios dentro de los objetos de la lista
        },
    },

    computed: {
        computed_lines(){
            return this.invoice.get_lines_with_additional_descriptions()
        },
        // totalGrossAmountBeforeTaxes(){
        //     let total = 0
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         total += line.gross_amount
        //     }
        //     if (total){
        //         return Math.trunc(total*100)/100
        //     }
        //     else{
        //         return 0
        //     }
        // },
        tax_type_to_show(){
            if(this.invoice.tax_type == 'igic'){
                return 'IGIC'
            }
            else{
                return 'IVA'
            }
        },
    },
    methods: {

        // getInvoiceDiscounts(){
        //     return [];
        // },

        // getInvoiceSurcharges(){
        //     return [];
        // },
        
        // getTaxes(){ //hauria d'usar camps factura (es van materialitzar)
        //     let taxes_comput = {}
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         let tax = line.taxes[0]
        //         let recargo = line.taxes[0].recargo_amount? line.taxes[0].recargo_amount : 0
        //         if (taxes_comput.hasOwnProperty(tax.rate)){
        //             taxes_comput[tax.rate].TaxableBase += tax.base
        //             taxes_comput[tax.rate].TaxAmount += tax.amount + recargo
        //         }
        //         else{
        //             taxes_comput[tax.rate] = {
        //                 TaxRate: tax.rate*100,
        //                 TaxableBase: tax.base,
        //                 TaxAmount: tax.amount + recargo
        //             }
        //         }
        //     }
        //     let items = []
        //     for (let key in taxes_comput){
        //         items.push(taxes_comput[key])
        //     }
        //     return items
            

        // },
        // getTaxesWithHeld(){
        //     return []
            

        // },

        // getLineDiscounts(line){
        //     return []
            
        // },
        // getLineCharges(line){
        //     return []
        // },
        payment_message(payment_means){
            return getPaymentMeansMessage(payment_means);
        },

        get_total_amount(invoice_line) {
            let gross = invoice_line.gross_amount;
            if (invoice_line.discounts.length > 0 && invoice_line.discounts[0].rate > 0)
                gross -= gross * invoice_line.discounts[0].rate / 100;
            let tax_amount = gross * invoice_line.taxes[0].rate;
            let recargo = 0;
            //console.log(invoice_line.taxes[0])
            if (invoice_line.taxes[0].recargo_amount) {
                recargo = invoice_line.taxes[0].recargo_amount;
            }
            let withheld_amount = 0;
            if (invoice_line.taxes_withheld.length) {
                withheld_amount = invoice_line.taxes_withheld[0].amount
            }
            return (gross + tax_amount + recargo - withheld_amount).toFixed(2);
        },
        formatInvoiceDate(date) {
          if (!date) return '';
          const [year, month, day] = date.split('-');
          return `${day}/${month}/${year}`;
        },
        // getWithheldTaxes(){
        //     let taxes_comput = {}
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         if (line.taxes_withheld.length){
        //             let tax = line.taxes_withheld[0]
        //             if (taxes_comput.hasOwnProperty(tax.rate)){
        //                 taxes_comput[tax.rate].TaxableBase += tax.base
        //                 taxes_comput[tax.rate].TaxAmount += tax.amount
        //             }
        //             else{
        //                 taxes_comput[tax.rate] = {
        //                     TaxRate: (tax.rate*100).toFixed(2),
        //                     TaxableBase: tax.base,
        //                     TaxAmount: tax.amount
        //                 }
        //             }
        //         }
        //     }
        //     let items = []
        //     for (let key in taxes_comput){
        //         items.push(taxes_comput[key])
        //     }
        //     return items
        // },
        formatField(field) {
            const fieldMap = {
                0.21: '21%',
                0.10: '10%',
                0.04: '4%',
                0.00: '0%',
                0.005: '4% RE 0.5%',
                0.014: '10% RE 1.4%',
                0.052: '21% RE 5.2%',
                na: '-',
                0.07: '7%',
                0.15: '15%',
                0.19: '19%',
                0.20: '20%',
            };

            return fieldMap[field] || field;
        }
    },
    

}
</script>


<style scoped>
.invoiceViewer {
    position: relative;
    min-height: 100vh;
    height: 100%;
    padding-bottom:10px;
    background-color: white;
    font-family: "Roboto", sans-serif !important;
    width: 100%;
    z-index: 0; /* Asegura que el contenido esté sobre la marca de agua */
}

.watermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg); /* Centrar y rotar */
    font-size: 150px;
    /*font-family: Ubuntu;*/
    color: rgba(200, 200, 200, 0.3);
    font-weight: bold;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none; 
    user-select: none;
    z-index: 1; /* Se mantiene encima */
}

.divider {
    border-width: 2px;
    border-color: var(--v-primary_blue-base);
}

.table {
    font-size: 12px;
    border: 1px solid #E6E6E6;
    width: 100%;
    border-collapse: collapse;
}

.table__header tr {
    color: #565656;
    background-color: #F4F4F4 !important;
    font-weight: 600;
}

.table__body tr {
    font-weight: 400;
    color: #565656;
}

.table td, th {
    padding: 8px;
    border: 1px solid #E6E6E6;
}

.table__total {
    width: 150px
}

.totals {
    font-size: 14px;
}

.custom-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 8px;
}

.custom-message-left{
    flex-grow: 1;
}
.custom-total {
    border-radius: 2px;
    border: 1px solid  rgba(87, 87, 87, 0.502);
    padding: 4px;
    width: 150px;
    margin-left: 40px;
    text-align: right;
    font-weight: 500;
}

.custom-total-last {
    border-radius: 2px;
    color:white;
    background-color: var(--v-primary_blue-base);
    padding: 4px;
    width: 150px;
    margin-left: 40px;
    text-align: right;
    font-weight: 600 !important;
}
.logo { 
    position: relative;
    top: 0;
    right: 0;
    margin-top: 20px;
    max-height: fit-content;
    min-height: fit-content;
    max-width: -webkit-fill-available;
    min-width: -webkit-fill-available;
} 

.first__row {
    position: relative;
    display: flex;
    flex-direction: column;
}

.description {
    font-size: 0.8em;
    color: gray;
    padding-left: 3px;
}

@media print {

    * {
        -webkit-print-color-adjust:exact !important;
        print-color-adjust:exact !important;
    }

    .logo {
        height: 130px !important;
        width: auto !important;        
    }

}
				
</style>